export default "__VITE_ASSET__DkT3XFcg__"